import { Color as ColorUtil } from "@/lib/utils/color"

ko.bindingHandlers["visibleTextColor"] =
   update: (element, valueAccessor) =>
      initColor = ko.unwrap(valueAccessor())
      $el = $(element)
      return unless initColor?

      textColor = ColorUtil.getVisibleTextColor(initColor)
      $el.css('color', textColor)